import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const updateBookingYachtBrokerNotes = async (bookingId: string, yachtBrokerNotes?: string) => {
    return fetch(`/api/bookings/${bookingId}/yacht-broker-notes`, "PATCH", { yachtBrokerNotes });
};

export const useBookingYachtBrokerNotesMutation = (bookingId: string) => {
    const queryClient = useQueryClient();
    const { toast } = useToast();

    return useMutation({
        mutationFn: (data: { yachtBrokerNotes?: string }) => updateBookingYachtBrokerNotes(bookingId, data.yachtBrokerNotes),
        onSuccess: () => {

            toast({
                title: "Success",
                description: "Yacht broker notes section updated successfully!",
                variant: "default",
            });

            queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
        },
        onError: (error: any) => {
            toast({
                title: "Error",
                description: error.message || "Failed to yacht broker notes section!",
                variant: "destructive",
            });
        },
    });
};
